import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { PatientHouseholdMemberDto } from '@/shared/interfaces';
import { fetch } from '@/shared/fetch';

export const unassociatedChildrenKeyAtom = atom((get) => [
    'UNASSOCIATED_CHILDREN',
]);
export const unassociatedChildrenAtom = atomWithQuery((get) => ({
    queryKey: get(unassociatedChildrenKeyAtom),
    queryFn: () =>
        fetch('/api/patients/lookup-unassociated-children') as Promise<
            PatientHouseholdMemberDto[]
        >,
}));
